import React from 'react';
import { successUpdateMsg } from '../../../../../components/atoms/const';
import Form from '../../../../../components/molecules/forms';
import Modal from '../../../../../components/organisms/modals';
import { DollarRefund } from '../../../../../components/atoms/icons';
import { renderDate } from '../utils';

interface Props {
    refundAmount: number | null;
    refundDate: string | null;
    id: number;
    modal: {
        load: boolean;
        after: () => void;
        result: any;
    };
    formik: any;
}

function RenderStatus(props: Props) {
  const {
    refundAmount, refundDate, id, modal, formik,
  } = props;
  const renderModalBody = React.useMemo(() => {
    if (modal.result) return successUpdateMsg.SUCCESS_SEND_REFUND;
    return (
      <div>
        <Form.Default
          id="refundAmount"
          placeholder="Enter Amount"
          type="number"
          value={formik.values.refundAmount}
          onBlur={formik.handleBlur}
          isInvalid={!!formik.errors.refundAmount && formik.touched.refundAmount}
          errorMsg={formik.errors.refundAmount}
          onChange={(e) => formik.setFieldValue('refundAmount', e.target.value)}
        />
      </div>
    );
  }, [modal.result, formik]);

  if (!refundAmount && !refundDate) {
    return (
      <div className="d-flex align-items-center justify-content-between" style={{ width: 120 }}>
        <div className="fz-14">Not-Refunded</div>
        <Modal.Default
          cancelLabel="Cancel"
          submitLabel="Refund"
          title="Send Refund"
          body={renderModalBody}
          closeButton
          isLoading={modal.load}
          onAfterResult={modal.after}
          result={modal.result}
          onInit={() => formik.setFieldValue('id', id)}
          onSubmit={formik.handleSubmit}
        >
          <div className="ms-2">
            <DollarRefund />
          </div>
        </Modal.Default>
      </div>
    );
  }
  return (
    <div className="d-flex justify-content-end align-items-center" style={{ width: 120 }}>
      <div className="fz-14 text-start w-100">
        <div>{`$${refundAmount ?? 0}`}</div>
        <div>{renderDate(refundDate)}</div>
      </div>
    </div>
  );
}

export default React.memo(RenderStatus);
